/**
 * Pesan error dashboard yang layak dibaca pengguna — SATU sumber logika.
 *
 * `ConvexError` mengirim data ke klien, tetapi `err.message` bawaan klien
 * Convex masih terbungkus prefix internal + Request ID
 * ("[CONVEX M(auth:signIn)] ... Server Error") sehingga tidak layak ditampilkan
 * di form login. Helper murni ini memilih berurutan:
 *
 *   1. `err.data` — pesan asli dari server (ConvexError, mis. "Email atau
 *      password salah." dari `auth.signIn`).
 *   2. `err.message` — error biasa (mis. gagal jaringan) apa adanya.
 *   3. `fallback` — kalau error bukan Error/objek yang bisa dibaca.
 *
 * Tanpa ConvexError, produksi menyensor pesan `Error` biasa menjadi
 * "Server Error" saja, jadi penyebab kegagalan tidak bisa dibedakan.
 */
export function userFacingErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === "object") {
    const data = (err as { data?: unknown }).data;
    if (typeof data === "string" && data.trim() !== "") return data;
    const message = (err as { message?: unknown }).message;
    if (typeof message === "string" && message.trim() !== "") return message;
  }
  return fallback;
}
